import { render, staticRenderFns } from "./pageFour.vue?vue&type=template&id=35aa3366"
import script from "./pageFour.vue?vue&type=script&lang=js"
export * from "./pageFour.vue?vue&type=script&lang=js"
import style0 from "../../../statistics/css/addProject.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports